export default "__VITE_ASSET__BELiIopK__"